import React, { FunctionComponent } from 'react'
import styled from 'styled-components'
import { GQLShopFieldsContentsShopInfoLayout } from '../generated/graphql'
import { Table } from './table'

const Outer = styled.div`
`

const Head = styled.div`

font-size: 1.125rem;
line-height: 1.6666666666666667;
letter-spacing: 0.02em;
color: var(--blue);
margin-top: 2rem;
font-weight: 700;
  padding: 1.1875rem 0;
  border-top: 1px solid #C1C1C1;
  border-bottom: 1px solid #C1C1C1;
  margin-top: 4.25rem;
@media (max-width: 40rem){
  font-size: 1.0625rem;
line-height: 1.4705882352941178;
  margin-top: 4.1875rem;
    padding-top: 1.3125rem;
    padding-bottom: 1.3125rem;
}
`

const TableContainer = styled.div`
  margin-top: 2.5rem;
  @media (max-width: 40rem){
    margin-top: 1.875rem;
  }
`

type ShopInfoProps = {
  data: DeepPartial<GQLShopFieldsContentsShopInfoLayout>
}
export const ShopInfo: FunctionComponent<ShopInfoProps> = ({data}) => {
  return <Outer>
    <Head>
      店舗情報
    </Head>
    <TableContainer>
    <Table data={data.table?.map(row => ({label: row?.label ?? '', value: row?.value ?? ''})) ?? []} />
    </TableContainer>
  </Outer>
}
